import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectUserImpersonation = createSelector([(state: AppState) => state.admin.userImpersonation], ({ data, fetching }) => ({
  data,
  fetching,
}));
